<template>
  <div>
    <v-dialog v-model="dialog.approved"
      @keydown.esc="dialog.approved = false"
      :fullscreen="dialog.fullscreen"
      width="750"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Setujui Ajuan
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.approved = false; $emit('close', true);"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>
        
        <v-list 
          color="transparent">
          <v-list-item>
            <v-list-item-avatar
              size="45"
              tile>
              <v-img
                :src="require('@/assets/image/verified.png')"
                style="border-radius: 10px;">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                class="body-1 font-weight-bold mb-2">
                Input Produk
              </v-list-item-title>

              <v-list-item-subtitle
                class="font-weight-light">
                Silahkan masukkan produk untuk ajuan tersebut dengan klik tombol <b class="font-weight-bold">"Tambah Produk"</b>.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-text v-if="form.produk.length < 1"
          class="px-4 pb-3 mt-2 d-flex align-center justify-center"
          style="height: 40vh;">
          <div @click="dialog.form = true; dialog.approved = false; fetch();"
            class="text-center cyan--text text-darken-1 cursor-pointer">
            <v-icon size="100" color="cyan">mdi-plus-circle-outline</v-icon>

            <div
              class="title mt-2 font-weight-bold">
              Tambah Produk
            </div>
          </div>
        </v-card-text>

        <v-card-text v-if="form.produk.length > 0"
          class="px-4 pb-3 mt-2">
          <v-btn 
            @click="dialog.form = true; dialog.approved = false; fetch();"
            elevation="0"
            style="background: #00acc133;"
            class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1 mb-4">
            <v-icon size="18">mdi-plus-circle-outline</v-icon>

            <span class="ml-1">
              Tambah Produk
            </span>
          </v-btn>

          <ValidationObserver ref="form">
            <v-form class="text-left">
              <v-list 
                flat 
                three-line
                color="transparent">
                <v-list-item-group>
                  <template>
                    <v-list-item 
                      v-for="(item, index) in form.produk"
                      :key="index"
                      :class="index < form.produk.length - 1 ? 'mb-4' : ''"
                      class="pl-3"
                      style="border-radius: 5px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;
                            background: #fff;
                            cursor: auto;">
                      <v-list-item-avatar 
                        tile 
                        size="40"
                        class="mr-3">
                        <v-img 
                          style="border-radius: 5px;"
                          alt="kominfo" 
                          :src="require(`@/assets/image/service/${item.layanan_kode}.png`)"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title 
                          class="body-2 font-weight-bold">
                          {{ item.layanan_kode }} - {{ item.nomor }}
                        </v-list-item-title>

                        <v-list-item-subtitle 
                          class="caption font-weight-light black--text mt-1 mb-2" 
                          style="opacity: 60%;">
                          <div
                            style="margin-bottom: 7px;">
                            <span
                              class="one-line text-uppercase">
                              {{ item.nama }}
                            </span>
                          </div>

                          <div
                            class="font-weight-bold"
                            :class="item.status === 'BELUM DIVERIFIKASI' || item.status === 'BELUM DIAJUKAN TTE' ? 'orange--text' :
                                    item.status === 'TIDAK DIPROSES' ? 'red--text' : 'cyan--text'">
                            <span
                              class="one-line">
                              {{ item.status }}
                            </span>
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn
                          @click="form.produk.splice(index, 1)"
                          small
                          elevation="0"
                          style="background: #f4403433;"
                          class="caption text-capitalize font-weight-bold d-flex align-center red--text px-2">
                          <v-icon small>mdi-delete-empty</v-icon>
                          
                          <span
                            class="ml-1">
                            Hapus
                          </span>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>

              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0">
                {{  message.error }}
              </v-alert>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider v-if="form.produk.length > 0" 
          class="mx-4 mb-3 mt-2"/>

        <v-card-actions v-if="form.produk.length > 0">
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save('DISETUJUI')"
            @click="save('DISETUJUI')">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.approved = false; $emit('close', true);">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Tambah Produk
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.approved = true;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form_add">
            <v-form class="text-left">
              <ValidationProvider 
                name="layanan_kode" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jenis Produk
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  style="max-width: 50%;"
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. KTP-EL"
                  
                  :items="list.service"
                  item-text="layanan_nama"
                  item-value="layanan_kode"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form_add.layanan_kode"
                  :success="form_add.layanan_kode.length > 0 && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis Produk {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_add.layanan_kode.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
              
              <div
                class="my-6">
                <ValidationProvider 
                  name="nomor" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    <!-- Nomor (KK/NIK/DLL) -->
                    Nomor Identitas
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-text-field
                    style="max-width: 70%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. 33100062XXXXXXX"
                    v-model="form_add.nomor"
                    v-uppercase
                    :success="form_add.nomor !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nomor {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form_add.nomor !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div
                class="my-6">
                <ValidationProvider 
                  name="nama" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    <!-- Nama (Nama Kepala Keluarga/Nama Lengkap/DLL) -->
                    Nama Identitas Produk
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-text-field
                    style="max-width: 70%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. Fabdulrafi"
                    v-model="form_add.nama"
                    v-uppercase
                    :success="form_add.nama !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nama {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form_add.nama !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <ValidationProvider 
                name="status" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Status
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  style="max-width: 60%;"
                  outlined
                  dense
                  color="#ff64ad"
                  :placeholder="form_add.layanan_kode === 'KTP' ? 'Contoh. SIAP DICETAK' : 'Contoh. DIAJUKAN TTE'"
                        
                  :items="form_add.layanan_kode === 'KTP' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'SIAP DICETAK',
                      'SUDAH DICETAK',
                      'SIAP DIAMBIL',
                      'TIDAK DIPROSES'
                    ] :
                    form_add.layanan_kode === 'SKT' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'TIDAK DIPROSES'
                    ] :
                    form_add.layanan_kode === 'KK' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'TIDAK DIPROSES'
                    ] :
                    form_add.layanan_kode === 'KIA' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'SIAP DICETAK',
                      'SUDAH DICETAK',
                      'SIAP DIAMBIL',
                      'SUDAH DIAMBIL',
                      'TIDAK DIPROSES'
                    ] :
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE'
                    ]"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form_add.status"
                  :success="form_add.status.length > 0 && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_add.status.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <div v-if="form_add.status === 'TIDAK DIPROSES'"
                class="mt-6">
                <div class="body-2 mb-2">
                  Keterangan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: 'Contoh. Alasan kenapa tidak diproses'
                  }"
                  v-model="form_add.note">
                </quill-editor>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="toAdd()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.form = false; dialog.approved = true; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.rejected"
      @keydown.esc="dialog.rejected = false"
      :fullscreen="dialog.fullscreen"
      width="750"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Tolak Ajuan
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.rejected = false; $emit('close', true);"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>
        
        <v-list 
          color="transparent">
          <v-list-item>
            <v-list-item-avatar
              size="45"
              tile>
              <v-img
                :src="require('@/assets/image/reject.png')"
                style="border-radius: 10px;">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                class="body-1 font-weight-bold mb-2">
                Input Alasan
              </v-list-item-title>

              <v-list-item-subtitle
                class="font-weight-light">
                Silahkan masukkan alasan penolakan ajuan tersebut.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-text
          class="px-4 pb-3 mt-2">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <div
                class="body-2 mb-2">
                <span class="red--text">*</span>
                Alasan Penolakan
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <quill-editor 
                ref="myTextEditor"
                :options="{
                  placeholder: 'Contoh. Foto KTP kurang jelas'
                }"
                v-model="form.note">
              </quill-editor>
              
              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0">
                {{  message.error }}
              </v-alert>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save('DITOLAK')"
            @click="save('DITOLAK')">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.rejected = false; $emit('close', true);">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.sure"
      @keydown.esc="dialog.sure = false"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Setujui Ajuan Belum Punya NIK
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.sure = false; $emit('close', true);"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-container>
          <v-row
            align="center"
            justify="center">
            <v-col 
              cols="12"
              md="10">
              <ValidationObserver ref="form">
                <v-form class="text-left">
                  <v-card
                    flat
                    class="pa-4 pb-0">
                    <v-img
                      contain
                      class="ma-auto"
                      width="160"
                      height="160"
                      alt="vuetify"
                      :src="require('@/assets/image/akl_file.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-card-text
                      class="text-center line-text-second mt-4">
                      Apakah Anda yakin meneruskan berkas ke lembar kerja Kartu Keluarga ? Jika iya, silahkan klik tombol <b>Simpan</b> untuk meneruskan berkas Akta Kelahiran.
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-col>
          </v-row>
        </v-container>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save('DISETUJUI TANPA NIK')"
            @click="save('DISETUJUI TANPA NIK')">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.sure = false; $emit('close', true);">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.upd"
      @keydown.esc="dialog.upd = false"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Setujui Ajuan Update Data
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.upd = false; $emit('close', true);"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-container>
          <v-row
            align="center"
            justify="center">
            <v-col 
              cols="12"
              md="10">
              <ValidationObserver ref="form">
                <v-form class="text-left">
                  <v-card
                    flat
                    class="pa-4 pb-0">
                    <v-img
                      contain
                      class="ma-auto"
                      width="160"
                      height="160"
                      alt="vuetify"
                      :src="require('@/assets/image/service/UPD.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-card-text
                      class="text-center line-text-second mt-4">
                      Apakah Anda yakin menyetujui ajuan Update Data ini ? Jika iya, silahkan klik tombol <b>Simpan</b> untuk menyetujui ajuan Update Data.
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-col>
          </v-row>
        </v-container>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save('DISETUJUI')"
            @click="save('DISETUJUI')">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.upd = false; $emit('close', true);">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <section>
      <v-container>
        <v-row
          align="center"
          justify="center">
          <v-col 
            cols="12"
            md="6">
            <v-card
              flat
              class="pa-4 pb-0">
              <v-img
                contain
                class="ma-auto"
                width="150"
                height="150"
                alt="vuetify"
                :src="require('@/assets/image/verified.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <v-card-text
                class="text-center line-text-second mt-4"
                :style="detail.ajuan_data_ajuan.field.nik === '' ? 'height: 130px;' : ''">
                <span v-if="detail.ajuan_layanan_kode !== 'UPD'">
                  <span v-if="detail.ajuan_data_ajuan.field.nik !== ''">
                    Jika Anda menyetujui ajuan ini, selanjutnya Anda akan di arahkan ke halaman input produk untuk ajuan tersebut.
                  </span>

                  <span v-else>
                    Jika Anda menyetujui ajuan ini, berkas akan dikirimkan ke lembar kerja Kartu Keluarga untuk proses input biodata bayi yang dibuatkan Akta Kelahiran.
                  </span>
                </span>

                <span v-if="detail.ajuan_layanan_kode === 'UPD'">
                  Jika Anda menyetujui ajuan ini, maka ajuan Update Data tersebut akan berstatus <b>SELESAI DIPROSES</b>. 
                </span>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  @click="toSave(detail.ajuan_data_ajuan.field.nik, detail.ajuan_layanan_kode)"
                  block
                  elevation="0"
                  color="green"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Setujui Ajuan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col 
            cols="12"
            md="6">
            <v-card
              flat
              class="pa-4 pb-0">
              <v-img
                contain
                class="ma-auto"
                width="150"
                height="150"
                alt="vuetify"
                :src="require('@/assets/image/reject.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <v-card-text
                class="text-center line-text-second mt-4"
                :style="detail.ajuan_data_ajuan.field.nik === '' ? 'height: 130px;' : ''">
                Jika Anda menolak ajuan ini, silahkan Anda masukkan alasan kenapa Anda menolak ajuan tersebut.
              </v-card-text>

              <v-card-actions>
                <v-btn
                  @click="dialog.rejected = true; $emit('close', false);"
                  block
                  elevation="0"
                  color="red"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Tolak Ajuan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          approved: false,
          rejected: false,
          form: false,
          sure: false,
          upd: false
        },
        list: {
          service: [],
          status: []
        },
        form: {
          // APPROVED
          id: '',
          no_reg: '',
          produk: [],

          // REJECTED
          status: '',
          note: ''
        },
        form_add: {
          nomor: '',
          layanan_kode: '',
          nama: '',
          status: '',
          note: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      fetch () {
        this.fetchService()
        this.fetchStatus()
      },
      async fetchService () {
        // let params = {
        //   limit: 10000,
        //   order_by: 'ASC',
        //   list_type: 'short',
        //   auth_role: 1
        // }

        // await get('layanan', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     this.list.service = res.data
        //   }
        // })

        // let params = {
        //   limit: 10000,
        //   order_by: 'ASC',
        //   list_type: 'short',
        //   auth_role: 1
        // }

        // this.list.service = []

        // await get('layanan', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     res.data.map((obj, index) => {
        //       if (index < 6) this.list.service.push(obj)
        //     })
        //   }
        // })

        let params = {
          limit: 10000,
          order_by: 'ASC',
          list_type: 'short',
          auth_role: 1
        }

        this.list.service = []

        await get('layanan/produk', { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            this.list.service = res.data
            
            // res.data.map((obj, index) => {
            //   if (index < 6 || index > 8) this.list.service.push(obj)
            // })
          }
        })
      },
      async fetchStatus () {
        // let params = {
        //   limit: 10000
        // }

        // await get('master/status_produk', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     this.list.status = res.data
        //   }
        // })

        this.list.status = [
          'BELUM DIVERIFIKASI',
          'BELUM DIAJUKAN TTE',
          'DIAJUKAN TTE',
          'SIAP DICETAK',
          'SUDAH DICETAK',
          'SIAP DIAMBIL',
          'TIDAK DIPROSES'
        ]
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form_add.reset()

        this.form_add = {
          nomor: item !== undefined ? item.nomor : '',
          layanan_kode: item !== undefined ? item.layanan_kode : '',
          nama: item !== undefined ? item.nama : '',
          status: item !== undefined ? item.status : '',
          note: item !== undefined ? item.note : ''
        }

        this.process.form = false
      },
      async toAdd () {
        const isValid = await this.$refs.form_add.validate()
        if (isValid) {
          this.form.produk.push(this.form_add)

          this.dialog.form = false
          this.dialog.approved = true

          this.reset()
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toSave (nik, code) {
        if (code !== 'UPD') {
          if (nik !== '') {
            this.dialog.approved = true
          } else {
            this.dialog.sure = true
          }
        } else {
          this.dialog.upd = true
        }

        this.$emit('close', false)
      },
      async save (status) {
        this.message.error = ''

        // if (this.detail.ajuan_data_ajuan.field.nik === '') {
        //   this.form.produk = [
        //     {
        //       layanan_kode: 'KK',
        //       nama: this.detail.ajuan_data_ajuan.field.nama_ayah,
        //       nomor: '',
        //       status: ''
        //       note: status
        //     }
        //   ]
        // }

        const isValid = await this.$refs.form.validate()
        if (isValid) {

          this.process.form = true

          this.form.id = this.detail.ajuan_id
          this.form.no_reg = this.detail.ajuan_no_reg
          this.form.status = status

          let url = ''

          if (this.detail.ajuan_layanan_kode !== 'UPD') {
            url = status !== 'DITOLAK' ? `admin/ajuan/${this.detail.ajuan_layanan_kode}/update_status_disetujui` : `admin/ajuan/${this.detail.ajuan_layanan_kode}/update_status`
          } else {
            url = `admin/ajuan/${this.detail.ajuan_layanan_kode}/update_status`
          }

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.code === 200) {
              this.dialog.approved = false

              this.dialog.rejected = false

              this.dialog.sure = false

              this.dialog.upd = false

              // let menu = status === 'DISETUJUI TANPA NIK' || this.detail.ajuan_layanan_kode === 'UPD' ? 0 : status === 'DITOLAK' ? 1 : 2

              // this.$emit('product', menu)

              if (status === 'DISETUJUI TANPA NIK') {
                this.$router.push('/worksheet?code=3')
              } else {
                let menu = this.detail.ajuan_layanan_kode === 'UPD' ? 0 : status === 'DITOLAK' ? 1 : 2
  
                this.$emit('product', menu)
              }

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>